const state = {
  digitalTextbookModule: localStorage.getItem('digitalTextbookModule')
    ? JSON.parse(localStorage.getItem('digitalTextbookModule'))
    : '',
  eTextbook: localStorage.getItem('eTextbook') ? JSON.parse(localStorage.getItem('eTextbook')) : '',
  digitalBook: localStorage.getItem('digitalBook') ? JSON.parse(localStorage.getItem('digitalBook')) : '',
  // catalogList: localStorage.getItem('catalogList') ? JSON.parse(localStorage.getItem('catalogList')) : '',
  catalogListByUse: localStorage.getItem('catalogListByUse')
    ? JSON.parse(localStorage.getItem('catalogListByUse'))
    : '',
  pdfIdMap: localStorage.getItem('pdfIdMap') ? JSON.parse(localStorage.getItem('pdfIdMap')) : ''
  // pdfList: localStorage.getItem('pdfList') ? JSON.parse(localStorage.getItem('pdfList')) : ''
}

const mutations = {
  // reset all
  SMART_TEACHING_SYSTEM_RESET_ALL(state, data) {
    const remove = [
      'digitalTextbookModule',
      'eTextbook',
      'digitalBook',
      'catalogList',
      'catalogListByUse',
      'pdfIdMap',
      'pdfList'
    ]
    for (const key in state) {
      if (Object.prototype.hasOwnProperty.call(state, key)) {
        if (remove.indexOf(key) > -1) {
          state[key] = data
          localStorage.removeItem(key)
        }
      }
    }
  },

  // digitalTextbookModule
  SMART_TEACHING_SYSTEM_DIGITAL_TEXTBOOK_MODULE(state, data) {
    state.digitalTextbookModule = data
    data === ''
      ? localStorage.removeItem('digitalTextbookModule')
      : localStorage.setItem('digitalTextbookModule', JSON.stringify(data))
  },

  // eTextbook
  SMART_TEACHING_SYSTEM_E_TEXTBOOK(state, data) {
    state.eTextbook = data
    data === '' ? localStorage.removeItem('eTextbook') : localStorage.setItem('eTextbook', JSON.stringify(data))
  },

  // digitalBook
  SMART_TEACHING_SYSTEM_DIGITAL_BOOK(state, data) {
    state.digitalBook = data
    data === '' ? localStorage.removeItem('digitalBook') : localStorage.setItem('digitalBook', JSON.stringify(data))
  },

  // catalogList
  SMART_TEACHING_SYSTEM_CATALOGS_LIST(state, data) {
    state.catalogList = data
    data === '' ? localStorage.removeItem('catalogList') : localStorage.setItem('catalogList', JSON.stringify(data))
  },

  // pdfIdMap
  SMART_TEACHING_SYSTEM_PDF_ID_Map(state, data) {
    state.pdfIdMap = data
    data === '' ? localStorage.removeItem('pdfIdMap') : localStorage.setItem('pdfIdMap', JSON.stringify(data))
  },

  // pdfList
  SMART_TEACHING_SYSTEM_PDF_LIST(state, data) {
    state.pdfList = data
    data === '' ? localStorage.removeItem('pdfList') : localStorage.setItem('pdfList', JSON.stringify(data))
  },

  // pdfInfo
  SMART_TEACHING_SYSTEM_PDF_INFO(state, data) {
    state.pdfInfo = data
    data === '' ? localStorage.removeItem('pdfInfo') : localStorage.setItem('pdfInfo', JSON.stringify(data))
  }
}

const actions = {
  // 清除所有信息
  resetAll({ commit }) {
    return new Promise(resolve => {
      commit('SMART_TEACHING_SYSTEM_RESET_ALL', '')
      resolve()
    })
  },
  // 设置电子教材模块信息
  setDigitalTextbookModule({ commit }, data) {
    return new Promise(resolve => {
      commit('SMART_TEACHING_SYSTEM_DIGITAL_TEXTBOOK_MODULE', data)
      resolve()
    })
  },
  // 设置电子课本--编辑
  setETextbook({ commit }, data) {
    return new Promise(resolve => {
      commit('SMART_TEACHING_SYSTEM_E_TEXTBOOK', data)
      resolve()
    })
  },
  // 设置PdfIdMap
  setPdfIdMap({ commit }, data) {
    return new Promise(resolve => {
      commit('SMART_TEACHING_SYSTEM_PDF_ID_Map', data)
      resolve()
    })
  },
  // 设置数字图书信息
  setDigitalBook({ commit }, data) {
    return new Promise(resolve => {
      // const { digitalBookCatalogList, pageControlList } = data
      commit('SMART_TEACHING_SYSTEM_DIGITAL_BOOK', data)
      // commit('SMART_TEACHING_SYSTEM_CATALOGS_LIST', digitalBookCatalogList)
      // commit('SMART_TEACHING_SYSTEM_PDF_LIST', pageControlList)
      resolve(data)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
